export const normalizeFileName = (name?: string): string | undefined => {
  return name?.replace(/[\<\>\:\"\/\\\|\?\*]/g, '');
};
